import { StructureItem } from "@/models/structure";
import {
    BaseTransformer,
    getPriceFromCalculationItem,
    getSumFromCalculationItem,
} from "./base.transformers";
import { unwrapRef } from "@/utils/reactive";
import { CalculationItem } from "@/models/calculate";
import {
    GlassPartition,
    GlassThinknessPartition,
} from "../entities/glass-partition";
import { getKompasMultiplier } from "@/app/predicates/systems.predicates";

type BaseGlassOldResponse = Pick<
    StructureItem,
    "glassSortCode" | "glassThicknessCode"
>;

interface BaseGlassTransformer<TNewResponse = GlassPartition>
    extends BaseTransformer<BaseGlassOldResponse, TNewResponse> { }

export const GlassTransformer: BaseGlassTransformer = {
    toOld(component: any) {
        const glass = component.getActiveGlass();
        const glassThickness = component.getActiveGlassThinkness();

        return {
            glassSortCode: glass?.structureType || "",
            glassThicknessCode: glassThickness?.structureType || "",
        };
    },
    fromOld(structure: StructureItem, calculations: CalculationItem[], systemCode?: string) {
        const price = getPriceFromCalculationItem(
            calculations,
            "glassPartition",
        );

        const sum = getSumFromCalculationItem(calculations, "glassPartition");

        const isPartition = structure.type === "partition";
        const glassItemQty = isPartition ? 1 : unwrapRef(structure.qty) || 1;
        const glassAreaMultiplier = getKompasMultiplier(systemCode || "");

        const glassPartition = new GlassPartition({
            structureType: structure.glassSortCode,
            price,
            sum,
            dimensions: {
                width: {
                    ft: 0,
                    inch: 0,
                    fractionDivisor: 0,
                    fractionDividend: 0,
                },
                height: {
                    ft: 0,
                    inch: 0,
                    fractionDivisor: 0,
                    fractionDividend: 0,
                },
                area:
                    parseFloat((structure.dimensions.areaFt as string) || "0") *
                    144 *
                    glassItemQty * glassAreaMultiplier,
            },
        });

        const glassThinkness = new GlassThinknessPartition({
            structureType: structure.glassThicknessCode,
        });

        glassPartition.addComponent(glassThinkness);

        return glassPartition;
    },
};
